import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdPencil: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 10 10" fill="none" {...props}>
      <Path
        d="M0.177867 9.23334L2.8873 8.52367C2.91195 8.51743 2.93453 8.50476 2.95265 8.48684L8.78034 2.66599C9.17487 2.27146 9.32894 1.69642 9.18457 1.15753C9.04012 0.618629 8.61914 0.197665 8.08027 0.0532212C7.54137 -0.0911291 6.96636 0.0629236 6.57181 0.457457L0.744114 6.28515C0.726193 6.30327 0.713423 6.32584 0.707185 6.35049L0.00463304 9.05993C-0.00813881 9.10874 0.00592016 9.16052 0.0415615 9.19616C0.0772028 9.2318 0.128983 9.24586 0.177794 9.23309L0.177867 9.23334ZM6.77353 0.657689C7.09628 0.334939 7.56677 0.208896 8.00763 0.327006C8.44851 0.44522 8.79283 0.789562 8.91107 1.23045C9.02918 1.67133 8.90315 2.1418 8.58039 2.46455L8.50662 2.53831L6.69977 0.731551L6.77353 0.657689ZM6.4982 0.928759L8.30931 2.73987L7.30153 3.7434L5.49467 1.93655L6.4982 0.928759ZM5.2932 2.13376L7.10145 3.94348L2.88598 8.15895L1.07913 6.35209L5.2932 2.13376ZM0.928703 6.60623L2.632 8.30952L0.339724 8.8985L0.928703 6.60623Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdPencil;
